import { render } from "./ServiceSubsystemComment.vue?vue&type=template&id=6628e7aa&scoped=true"
import script from "./ServiceSubsystemComment.vue?vue&type=script&lang=js"
export * from "./ServiceSubsystemComment.vue?vue&type=script&lang=js"

import "./ServiceSubsystemComment.vue?vue&type=style&index=0&id=6628e7aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6628e7aa"]])

export default __exports__